import { InlineNotification } from '@carbon/react';
import { CreateFullPageStep } from '@carbon/ibm-products';
import { MessageDescriptor, useIntl } from 'react-intl';

import styles from '../../InitialSetupModal.module.scss';
import SummaryTile from './components/SummaryTile';

type Props = {
    title: MessageDescriptor;
    description: MessageDescriptor;
    submitFailedTitle: MessageDescriptor;
    setupError: string;
    onMount?: () => void;
    summaryData: {
        groupLabel: MessageDescriptor;
        groupRows: Array<{ key: string; label: string; value: string }>;
        categoriesLabel: MessageDescriptor;
        categoriesRows: Array<{ key: string; label: string; value: string }>;
        peopleLabel: MessageDescriptor;
        peopleRows: Array<{ key: string; label: string; value: string }>;
        subscriptionLabel: MessageDescriptor;
        subscriptionRows: Array<{ key: string; label: string; value: string }>;
        paymentLabel: MessageDescriptor;
        paymentRows: Array<{ key: string; label: string; value: string }>;
        invoiceDetailsLabel: MessageDescriptor;
        invoiceDetailsRows: Array<{ key: string; label: string; value: string }>;
    };
};

const SummaryStep = ({
    title,
    description,
    submitFailedTitle,
    setupError,
    onMount,
    summaryData,
}: Props) => {
    const intl = useIntl();

    return (
        <CreateFullPageStep
            title={intl.formatMessage(title)}
            fieldsetLegendText=""
            onMount={onMount}
        >
            <div className={styles.stepContainer}>
                <p>{intl.formatMessage(description)}</p>

                {setupError && (
                    <InlineNotification
                        kind="error"
                        title={intl.formatMessage(submitFailedTitle)}
                        subtitle={setupError}
                        hideCloseButton
                    />
                )}

                <div className={styles.summaryGrid}>
                    <SummaryTile label={summaryData.groupLabel} rows={summaryData.groupRows} />
                    <SummaryTile label={summaryData.categoriesLabel} rows={summaryData.categoriesRows} />
                    <SummaryTile label={summaryData.peopleLabel} rows={summaryData.peopleRows} />
                    <SummaryTile label={summaryData.subscriptionLabel} rows={summaryData.subscriptionRows} />
                    <SummaryTile label={summaryData.paymentLabel} rows={summaryData.paymentRows} />
                    <SummaryTile label={summaryData.invoiceDetailsLabel} rows={summaryData.invoiceDetailsRows} />
                </div>
            </div>
        </CreateFullPageStep>
    );
};

export default SummaryStep;
